// extracted by mini-css-extract-plugin
export default {"departments":"AH-z","departmentHeading":"BH-z","departmentSection":"CH-z","departmentName":"DH-z","departmentLink":"EH-z","expandIcon":"FH-z"};